import {useEffect, useState} from "react";
import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";
import * as S from './styles'

import StaticImage from '../../../../assets/images/business/b_m_banner_pre_load_back.png';
import AnimatedImage from '../../../../assets/images/business/b_m_banner_back.webp'
import Phone from '../../../../assets/images/business/b_m_banner_phone.png'
import PhoneDark from '../../../../assets/images/business/b_m_banner_phone_dark.png'

import {ReactComponent as TwitterIcon} from '../../../../assets/icons/social/tv_b.svg';
import {ReactComponent as FacebookIcon} from '../../../../assets/icons/social/fb_b.svg';
import {ReactComponent as InstagramIcon} from '../../../../assets/icons/social/inst_b.svg';
import {ReactComponent as VKIcon} from '../../../../assets/icons/social/vk_b.svg';
import {ReactComponent as LinkedInIcon} from '../../../../assets/icons/social/in_b.svg';
import {View} from "../../../../styles/business-components";


export const Banner = observer(() => {
    const { businessStore, uiStore } = useStores()

    const [imagePath, setImagePath] = useState(StaticImage);

    useEffect(() => {
        const img = new Image();
        img.src = AnimatedImage;
        img.onload = () => {
            setImagePath(AnimatedImage);
        };
    }, []);

    const isLightTheme = uiStore.isLightTheme;

    return (
        <S.Container>
            <S.Banner imagePath={imagePath} staticImagePath={StaticImage}>
                <S.Logo>
                    <S.Phone src={isLightTheme ? Phone : PhoneDark}/>
                    <S.Text1>Надежный</S.Text1>
                    <S.Text2>Защищенный</S.Text2>
                    <S.Text3>Исключительный</S.Text3>
                </S.Logo>

                <View>
                    <S.Info>
                        <S.InfoTitle>СКИДКА 10% ДЛЯ БИЗНЕС-ПАРТНЕРОВ</S.InfoTitle>
                        <S.InfoText>При регистрации заранее мы сообщим вам о запуске версии Teleguard Business</S.InfoText>
                        <S.InfoLink to={'/'}>Узнать подробности {'>'}</S.InfoLink>
                    </S.Info>
                </View>

                <S.ButtonWrapper>
                    <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}><Uppercase>Запростиь консультацию</Uppercase></Button>
                </S.ButtonWrapper>
            </S.Banner>

            <S.SocialBlock>
                <S.SocialLink to={'/'}><TwitterIcon/></S.SocialLink>
                <S.SocialLink to={'/'}><FacebookIcon/></S.SocialLink>
                <S.SocialLink to={'/'}><InstagramIcon/></S.SocialLink>
                <S.SocialLink to={'/'}><VKIcon/></S.SocialLink>
                <S.SocialLink to={'/'}><LinkedInIcon/></S.SocialLink>
            </S.SocialBlock>
        </S.Container>
    )
})